module.exports = __webpack_public_path__ + "static/img/475473ac8a58e5716a43b2a2791a0bac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro4.jpg
// module id = Oc7A
// module chunks = 1